import{__decorate as t,e as i,n as o}from"../../d4cffba7.js";import{n as r,r as s,y as e,x as a}from"../../493beda6.js";import{exportParts as n}from"../../directives/ExportParts.js";import{PanelSection as c}from"./sections/PanelSection.js";import{Thumbnail as l}from"../Thumbnail.js";import{Icon as p}from"../Icon.js";import{defaultStyles as d}from"../../styles.js";import{parseISO as m,isValid as g,format as h}from"../../0ad16d3f.js";import"../../f75f919c.js";import"../../af1106fb.js";import"../Popover.js";import"../../icons/monochrome/help.js";import"../Tooltip.js";import"../../utils.js";import"../../icons/monochrome/broken-image.js";import"../../icons/color/info.js";import"../../icons/color/alert.js";import"../../icons/color/missing.js";import"../../icons/color/logos/adobe-stock.js";import"../../icons/color/logos/adobe.js";import"../../icons/color/logos/behance.js";import"../../icons/color/logos/cai.js";import"../../icons/color/logos/facebook.js";import"../../icons/color/logos/instagram.js";import"../../icons/color/logos/photoshop.js";import"../../icons/color/logos/truepic.js";import"../../icons/color/logos/twitter.js";var v,b={HEADER:"Content Credentials",HELP_TEXT:"Attribution and history data attached to this content",INVALID_DATE:"Invalid date",VIEW_MORE:"View more"};let j=v=class extends r{constructor(){super(...arguments),this.stringMap=b,this.claim={},this.viewMoreUrl="",this.dateFormat="MMM d, yyyy 'at' h:mm aa"}static get styles(){return[d,s`
        #content {
          --cai-thumbnail-size: 48px;
          display: grid;
          grid-template-columns: 48px auto;
          grid-gap: 2px 10px;
          text-align: left;
          margin-bottom: 20px;
        }
        #thumbnail {
          grid-column: 1;
          grid-row: 1 / 3;
        }
        #signer {
          grid-column: 2;
          grid-row: 1;
          align-self: flex-end;
          display: grid;
          grid-template-columns: min-content max-content;
          align-items: center;
          font-size: var(--cai-font-size-lg, 15px);
          font-weight: bold;
        }
        #date {
          grid-column: 2;
          grid-row: 2;
        }
        #view-more {
          background-color: #999;
          border-radius: 20px;
          color: white;
          display: block;
          font-size: var(--cai-font-size-lg, 15px);
          font-weight: bold;
          margin-top: 20px;
          padding: 10px 0;
          text-align: center;
          text-decoration: none;
          width: 100%;
        }
      `]}render(){const t=this.claim.signatureDate?m(this.claim.signatureDate):void 0;return e`<div id="container" part=${v.cssParts.container}>
      <div slot="header">
        <cai-panel-section
          header=${this.stringMap.HEADER}
          helpText=${this.stringMap.HELP_TEXT}
          exportparts=${n(c.cssParts)}
        >
          <div id="content" part=${v.cssParts.content}>
            <cai-thumbnail
              id="thumbnail"
              part=${v.cssParts.thumbnail}
              src=${this.claim.thumbnailUrl}
              badge="none"
              badgehelptext=""
              exportparts=${n(l.cssParts)}
            ></cai-thumbnail>
            <div id="signer" part=${v.cssParts.signer}>
              <cai-icon
                slot="icon"
                source=${this.claim.signer}
                exportparts=${n(p.cssParts)}
              ></cai-icon>
              <div>${this.claim.signer}</div>
            </div>
            <div id="date" part=${v.cssParts.date}>
              ${g(t)?e`${h(t,this.dateFormat)}`:e`${this.stringMap.INVALID_DATE}`}
            </div>
          </div>
        </cai-panel-section>
      </div>
      <slot name="sections"></slot>
      ${this.viewMoreUrl?e`
            <a
              id="view-more"
              href=${this.viewMoreUrl}
              target="_blank"
              part=${v.cssParts.viewMore}
            >
              ${this.stringMap.VIEW_MORE}
            </a>
          `:a}
    </div>`}};j.cssParts={container:"discrete-panel-container",content:"discrete-panel-content",signer:"discrete-panel-signer",date:"discrete-panel-date",thumbnail:"discrete-panel-thumbnail",viewMore:"discrete-panel-view-more"},t([i({type:Object})],j.prototype,"stringMap",void 0),t([i({type:Object})],j.prototype,"claim",void 0),t([i({type:String})],j.prototype,"viewMoreUrl",void 0),t([i()],j.prototype,"dateFormat",void 0),j=v=t([o("cai-discrete-panel")],j);
